export const REPOSITORIES_URL = '/repository/v2/reports';
